<template>
    <div class="container pt-2">
        <PageTitle icon="fa fa-address-card" main="Validação de Jobs" sub="Página para validar os jobs" />
        <!-- VALIDAÇÃO -->
        <b-modal id="modal-valida" hide-footer>
            <template v-slot:modal-title>
                Validação do Serviço:
            </template>
            <div class="row">
                <div class="col-md-12">
                    <a :href="job.resultado" class="btn btn-info btn-block">Abrir Resultado</a>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-button variant="success" class="mt-3" block @click="setValida">Validar Resultado</b-button>
                </div>
                <div class="col-md-6">
                    <b-button variant="danger" class="mt-3" block @click="setRetorna">Rejeitar Resultado</b-button>
                </div>
            </div>
        </b-modal>

        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-jobs" 
                class="text-center table table-sm" 
                :items="jobs" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(servico)="data">
                    {{ data.item.categoria_titulo }}->{{ data.item.subcategoria_titulo }}->{{ data.item.id_tiposervico_titulo }}
                </template>
                <template v-slot:cell(actions)="data">
                    <b-button variant="success" class="mr-2 btn-sm mb-1" @click="openValida(data.item)">
                        <font-awesome-icon :icon="['fa', 'file-export']"/>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-jobs"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
        <div v-else>
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-jobs" 
                class="text-center table table-sm" 
                :items="jobs" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(servico)="data">
                    {{ data.item.categoria_titulo }}->{{ data.item.subcategoria_titulo }}->{{ data.item.id_tiposervico_titulo }}
                </template>
                <template v-slot:cell(actions)="data">
                    <b-button variant="success" class="mr-2 btn-sm mb-1" @click="openValida(data.item)">
                        <font-awesome-icon :icon="['fa', 'file-export']"/>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-jobs"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'validaJobs',
    components: { PageTitle },
    data: function() {
        return {
            jwt: new VueEasyJwt(),
            nivel: '',
            job: {},
            jobs: [],
            transacao1: {},
            transacao2: {},
            quemRecebeu: '',
            exibeRodape: true,
            currentPage: 1,
            filtro: null,
            filtrando: [],
            totalRows: 1,
            fields: [
                { key: 'numero', label: 'Número', sortable: true },
                { key: 'servico', label: 'Serviço', sortable: true },
                { key: 'dataPublicacao', label: 'Data de Publicação', sortable: true, formatter: 'formatData' },
                { key: 'id_tiposervico_datavalidade', label: 'Data Limite', sortable: true, formatter: 'formatData' },
                { key: 'dataFinalizacao', label: 'Data de Finalização', sortable: true, formatter: 'formatData' },
                { key: 'actions', label: 'Ações', thStyle: { width: '20%' }  }
            ],
            larguraTela: 0,
            overflowValue: 'auto'
        }
    },
    computed: {
        rows() {
            return this.jobs.length
        }
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        openValida(job) {
            this.job = job
            this.$bvModal.show('modal-valida')
        },
        setValida() {
            axios['put'](`${baseApiUrl}/backend/GENERAL/validaJob.php?id=${this.job.id}`, this.job)
            .then(() => {
                this.$bvModal.hide('modal-valida')

                this.transacao1.id_colaborador = 999
                this.transacao1.id_job = this.job.id
                this.transacao1.id_servico = this.job.id_tiposervico
                this.transacao1.status = 'REPASSE_JOB_' + this.job.id
                this.transacao1.tipo = 'debito'
                this.transacao1.valor = this.job.id_tiposervico_valor_pagar
                this.transacao1.liberado = 'sim'
                axios['post'](`${baseApiUrl}/backend/INSERT/transacoes.php`, this.transacao1)
                .then(() => {
                    })
                .catch((e) => {
                    this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                })

                this.transacao2.id_colaborador = this.job.quemRecebeu
                this.transacao2.id_job = this.job.id
                this.transacao2.id_servico = this.job.id_tiposervico
                this.transacao2.status = 'RECEBIMENTO_JOB_' + this.job.id
                this.transacao2.tipo = 'credito'
                this.transacao2.valor = this.job.id_tiposervico_valor_pagar
                this.transacao2.liberado = 'sim'
                axios['post'](`${baseApiUrl}/backend/INSERT/transacoes.php`, this.transacao2)
                .then(() => {
                    this.$toasted.global.defaultSuccess({ message : 'Serviço finalizado com sucesso!' })
                })
                .catch((e) => {
                    this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                })

                this.reset()
            })
            .catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
            })
        },
        setRetorna() {
            axios['put'](`${baseApiUrl}/backend/GENERAL/retornaJob.php?id=${this.job.id}`, this.job)
            .then(() => {
                this.$bvModal.hide('modal-valida')
                this.$toasted.global.defaultSuccess({ message : 'Serviço retornado com sucesso!' })
                this.reset()
            })
            .catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
            })
        },
        reset() {
            this.job = {}
            this.transacao1 = {}
            this.transacao2 = {}
            this.loadJobs()
        },
        formatData(value) {
            const arr = value.split('-')
            const y = arr[0]
            const m = arr[1]
            const d = arr[2]
            return `${d}/${m}/${y}`
        },
        loadJobs() {
            const url = `${baseApiUrl}/backend/SELECT/jobsByStatus.php?status=AGUARDANDO VALIDACAO`
            axios.get(url).then(res => {
                this.jobs = res.data
                this.exibeRodape = false
            }).catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                this.exibeRodape = true
            })
        },
        loadJob(job) {
            this.job = { ...job }
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.nivel = decodedToken['data'].nivel
                this.quemRecebeu = decodedToken['data'].id
            }
        }
    },
    mounted() {
        this.validaLogin()
        if(this.nivel !== 'admin') {
            this.$router.push('/')
        }
        this.loadJobs()
        this.larguraTela = screen.width - (screen.width * 0.08)
        this.totalRows = this.jobs.length
    }
}
</script>

<style>
.table {
    font-size: 0.9rem;
}

.text-custom {
    font-size: 0.8rem;
}
</style>